<div class="code-input-container" (click)="openModal(field)">
    <span class="name">{{field.name}}</span>
    <span class="change" trans>Modify</span>
</div>